import { jsx } from "panel";
import { ProfileActivityEl } from "common/widgets/profile-activity";
import { ProfileUserSummaryEl } from "common/widgets/profile-user-summary";
import { ToggleEl } from "common/components/toggle";
import { ToggleTheme } from "common/components/toggle/types";
import { ProfileDemographicsEl } from "../profile-demographics";
import { UserDetailTab } from "./types";
import toggleOverride from "./toggle-override.inline.styl";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".profile-sidebar-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".profile-sidebar-header"
  }), /* @__PURE__ */ jsx("div", {
    sel: ".profile-sidebar-summary"
  }, /* @__PURE__ */ jsx(ProfileUserSummaryEl, {
    attrs: this.helpers.getUserSummaryAttrs()
  })), /* @__PURE__ */ jsx("div", {
    sel: ".profile-sidebar-tabs"
  }, /* @__PURE__ */ jsx(ToggleEl, {
    attrs: {
      theme: ToggleTheme.TabBar,
      selected: this.state.selectedTab,
      "style-override": toggleOverride,
      options: [
        { label: `Activities`, value: UserDetailTab.Activities },
        { label: `User Properties`, value: UserDetailTab.Properties }
      ]
    },
    on: {
      select: this.handleTabSelect
    }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".profile-sidebar-body"
  }, this.state.selectedTab === UserDetailTab.Properties && /* @__PURE__ */ jsx(ProfileDemographicsEl, {
    attrs: this.helpers.getUserDemographicAttrs()
  }), this.state.selectedTab === UserDetailTab.Activities && /* @__PURE__ */ jsx(ProfileActivityEl, {
    attrs: this.helpers.getUserActivityAttrs()
  })));
}
